import { useState, useEffect } from 'react'
import { WifiOff, Loader2, RefreshCw } from 'lucide-react'
import type { TransportConnectionState } from '../transport/client'
import { getClient } from '../transport/connection'

interface ConnectionBannerProps {
  onRescan: () => void
}

export function ConnectionBanner({ onRescan }: ConnectionBannerProps) {
  const [state, setState] = useState<TransportConnectionState | null>(null)

  useEffect(() => {
    const client = getClient()
    if (!client) return

    return client.onConnectionStateChanged(setState)
  }, [])

  if (!state || state.status === 'connected') return null

  const isReconnecting = state.status === 'reconnecting'
  const isFailed = state.status === 'failed'
  const nextRetrySeconds = state.nextRetryInMs ? Math.ceil(state.nextRetryInMs / 1000) : null

  return (
    <div className="flex items-center justify-between gap-3 bg-amber-500/10 px-4 py-2 text-sm text-amber-500 border-b border-amber-500/20">
      <div className="flex items-center gap-2">
        {isReconnecting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <WifiOff className="h-4 w-4" />
        )}
        <span>
          {isReconnecting
            ? `Reconnecting${nextRetrySeconds ? ` in ${nextRetrySeconds}s` : '...'}${state.attempt > 1 ? ` (attempt ${state.attempt})` : ''}`
            : isFailed
              ? state.lastError?.message || 'Connection failed'
              : 'Disconnected'
          }
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => getClient()?.reconnectNow()}
          className="flex items-center gap-1 rounded px-2 py-1 text-xs font-medium hover:bg-amber-500/20 transition-colors"
        >
          <RefreshCw className="h-3 w-3" />
          Retry
        </button>
        <button
          onClick={onRescan}
          className="rounded px-2 py-1 text-xs font-medium hover:bg-amber-500/20 transition-colors"
        >
          Re-scan
        </button>
      </div>
    </div>
  )
}
